import { render, staticRenderFns } from "./my_model.vue?vue&type=template&id=565996ff&scoped=true&"
import script from "./my_model.vue?vue&type=script&lang=js&"
export * from "./my_model.vue?vue&type=script&lang=js&"
import style0 from "./my_model.vue?vue&type=style&index=0&id=565996ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565996ff",
  null
  
)

export default component.exports